
import React from 'react';
import { RefreshCcw, Receipt } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface PaymentListHeaderProps {
  refreshing: boolean;
  isOnline: boolean;
  pageSizeOptions: number[];
  pageSize: number;
  onRefresh: () => void;
  onPageSizeChange: (newSize: string) => void;
  onRecordPayment: () => void;
}

const PaymentListHeader: React.FC<PaymentListHeaderProps> = ({
  refreshing,
  isOnline,
  pageSizeOptions,
  pageSize,
  onRefresh,
  onPageSizeChange,
  onRecordPayment
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onRefresh}
          disabled={refreshing || !isOnline}
        >
          <RefreshCcw className={`h-4 w-4 mr-2 ${refreshing ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
        
        <Button
          size="sm"
          onClick={onRecordPayment}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          <Receipt className="h-4 w-4 mr-2" />
          Record Payment
        </Button>
      </div>
      
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">
          Items per page:
        </span>
        <Select
          value={pageSize.toString()}
          onValueChange={onPageSizeChange}
        >
          <SelectTrigger className="w-[80px] h-8">
            <SelectValue placeholder={pageSize.toString()} />
          </SelectTrigger>
          <SelectContent>
            {pageSizeOptions.map(size => (
              <SelectItem key={size} value={size.toString()}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default PaymentListHeader;
